<template>
          <div class="row" v-if="isEdit">
                <!-- Modern Icons Wizard -->
                <div class="col-12 mb-4">
                  <div class="bs-stepper wizard-icons wizard-icons-example mt-2">
                    
                    <div class="row g-4" style="padding: 10px;">
                        <div class="col-sm-10">
                          <h2 class="card-header">Modification fiche prospection <span class="text-primary"><u><b>{{ prospect.nom_societe }}</b></u></span></h2>
                        </div>
                        <div class="col-sm-2 text-end">
                          <button @click="closeEdit()" type="button" class="btn btn-danger waves-effect waves-light">Annuler</button>
                        </div>
                      </div>
                    <div class="bs-stepper-content">
                      
                      <form @submit="addProspect($event)">
                        <!-- Account Details -->
                        <div id="account-details-modern" :class="{'content' : true, 'active': true, 'dstepper-block' : true}">
                          <div class="row g-4 mb-4 align-items-center">
                            <div class="col-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_admin">
                                        <option v-for="admin in admins" :value="admin.id">{{ admin.nom }} {{ admin.prenoms}}</option>
                                     </select>
                                     <label for="selectpickerBasic">Gestionnaire</label>
                                 </div>
                            </div>
                            <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="Nom de la société" v-model="prospect.suivi">
                                <label for="username-modern">Suivi par</label>
                              </div>
                            </div>
                          </div>
                          <div class="row g-4">
                            <div class="col-sm-4">
                              <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="Nom de la société" v-model="prospect.nom_societe">
                                <label for="username-modern">Nom de la société</label>
                              </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_sector">
                                      <option v-for="secteur in secteurs" :value="secteur.id">{{ secteur.libelle_sector }}</option>
                                     </select>
                                     <label for="selectpickerBasic">Secteur d'activité</label>
                                 </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="Effectif" v-model="prospect.effectif">
                                <label for="username-modern">Effectif</label>
                              </div>
                            </div>
                           <div class="row g-4">
                            <div class="col-sm-3">
                                <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="DG" v-model="prospect.dg">
                                <label for="username-modern">DG</label>
                              </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="DRH" v-model="prospect.drh">
                                <label for="username-modern">DRH</label>
                              </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="Interlocuteur" v-model="prospect.interlocuteur">
                                <label for="username-modern">Interlocuteur</label>
                              </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="Contact" v-model="prospect.contact_societe">
                                <label for="username-modern">Contact société</label>
                              </div>
                            </div>
                           </div>
                           <div class="row g-4">
                              <div class="col-sm-4">
                                    <Calendar dateFormat="dd/mm/yy" placeholder="Date 1er contact" v-model="prospect.date_premier_contact"  showIcon style="width: 100%;"/>
                              </div>
                            <div class="col-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_nature_prospection">
                                      <option v-for="prospection in prospections" :value="prospection.id">{{ prospection.libelle_nature_prospection }}</option>
                                     </select>
                                     <label for="selectpickerBasic">Nature prospection</label>
                                 </div>
                            </div>
                            <div class="col-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.interesse">
                                      <option value="oui">Oui</option>
                                      <option value="non">Non</option>
                                     </select>
                                     <label for="selectpickerBasic">Interessé</label>
                                 </div>
                            </div>
                           </div>
                          </div>
                        </div>
                        <hr  style="margin: 30px auto;  border: 1px solid #7a7a7a; width: 100%;">
                        <!-- Personal Info -->
                        <div id="personal-info-modern" :class="{'content' : true, 'active': true, 'dstepper-block' : true}">
                          <div class="row g-4">
                            <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.id_garanties">
                                        <option v-for="garantie in garanties" :value="garantie.id">{{ garantie.libelle_garantie}}</option>
                                     </select>
                                     <label for="selectpickerBasic">Garanties</label>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.type_contrat">
                                        <option value="groupe-ouvert">Groupe ouvert</option>
                                        <option value="groupe-ferme">Groupe fermé</option>
                                     </select>
                                     <label for="selectpickerBasic">Type contrat</label>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default"  v-model="prospect.liste_cotation">
                                        <option value="oui">Oui</option>
                                        <option value="non">Non</option>
                                     </select>
                                     <label for="selectpickerBasic">Liste pour Cotation</label>
                                </div>
                            </div>
                            <div class="row g-4">
                              <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                <input type="text" id="username-modern" class="form-control" placeholder="CA" v-model="prospect.prevision_annuelle">
                                <label for="username-modern">CA</label>
                              </div>
                            </div>
                            <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default" v-model="prospect.projet_convention">
                                        <option value="oui">Oui</option>
                                        <option value="non">Non</option>
                                     </select>
                                     <label for="selectpickerBasic">Projet convention</label>
                                </div>
                            </div>
                            <div class="col-sm-4">
                                  <div class="form-floating form-floating-outline">
                                      <select  class="form-select form-select-lg" data-style="btn-default"  v-model="prospect.offre_commerciale">
                                          <option value="oui">Oui</option>
                                          <option value="non">Non</option>
                                      </select>
                                      <label for="selectpickerBasic">Offre commerciale</label>
                                   </div>
                              </div>
                            </div>
                            <div class="row g-4">
                            <div class="col-sm-6" v-if="prospect.offre_commerciale=='oui'">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default">
                                        <option value="oui">Personnalisée</option>
                                        <option value="non">Standard</option>
                                     </select>
                                     <label for="selectpickerBasic">Type offre</label>
                                </div>
                            </div>
                            </div>
                            <hr  style="margin:  auto;  border: 1px solid #7a7a7a; width: 100%;">
                            <div class="row g-4">
                              <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default">
                                        <option value="oui">Oui</option>
                                        <option value="non">non</option>
                                     </select>
                                     <label for="selectpickerBasic">Validation projet</label>
                                </div>
                              </div>
                              <div class="col-sm-4">
                                <div class="form-floating form-floating-outline">
                                     <select  class="form-select form-select-lg" data-style="btn-default">
                                        <option value="oui">Oui</option>
                                        <option value="non">non</option>
                                     </select>
                                     <label for="selectpickerBasic">Signature</label>
                                </div>
                              </div>
                              <div class="col-sm-4">
                                    <Calendar dateFormat="dd/mm/yy" placeholder="Dernier contact" v-model="prospect.dernier_contact"  showIcon style="width: 100%;"/>
                              </div>
                            </div>
                            <div class="row g-4">
                              <div class="col-sm-6">
                                <label for="selectpickerBasic">Règlement</label>
                                <textarea v-model="prospect.reglements"  class="form-control" placeholder="Observation" aria-label="Observation" aria-describedby="basic-icon-default-message2"></textarea>
                              </div>
                              <div class="col-sm-6">
                                <label for="selectpickerBasic">Observation</label>
                                <textarea v-model="prospect.observations"  class="form-control" placeholder="Observation" aria-label="Observation" aria-describedby="basic-icon-default-message2"></textarea>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="text-end">
                                <button type="submit" class="btn btn-primary btn-next waves-effect waves-light">
                                    <span class="align-middle d-sm-inline-block d-none me-sm-1">Enregistrer</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                
              </div>
  </template>
  
  <script>
    import Calendar from 'primevue/calendar';
    
    import "vue-toastification/dist/index.css";
    import { useToast } from "vue-toastification";
    const toast = useToast();
  
    export default {
        name: 'AjoutProspect',
        components : {
            Calendar
        },
        props: {
            isEdit : Boolean,
            admins : Array,
            garanties : Array,
            secteurs : Array,
            prospections : Array,
            prospect : Object
        },
        data() {
            return {
                step_one : true,
                step_two : false,
                step_three : false,
                
            }
        },
        mounted(){
            
        },
        computed : {
              toNext(){
               return this.prospect.id_admin == '' || this.prospect.nom_societe == '' || 
               this.prospect.date == '' || this.prospect.id_sector == '' || this.prospect.effectif == '' ||
               this.prospect.dg == '' || this.prospect.drh == '' || this.prospect.interlocuteur == '' || 
               this.prospect.contact_societe == '' || this.prospect.id_nature_prospection == '' || this.prospect.interesse == ''
              }
          },
        methods : {
            closeEdit(){
                this.$emit('closeEdit')
            },
            async addProspect(e){
                e.preventDefault()
                const datas = new FormData()
                    for(const objet in this.prospect){
                      datas.append(objet, this.prospect[objet])
                    }
                    let response = await this.$axios.post('prospect/add', datas);
                      if(response.data.code ==400){
                          toast.error(response.data.message)
                          return
                      }
                      
                      toast.success(response.data.message)
                    this.resetDatas()
                  this.$emit('AjoutProspect')
            },
            goStepTwo(){
                this.step_one = false
                this.step_two = true
            },
            prevStepOne(){
                this.step_one = true
                this.step_two = false
            },
            resetDatas(){
              return
            }
        },
        beforeMount(){
            
        }
    }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  .btn-danger{
    /* float: right !important; */
    /* margin-bottom: 20px; */
  }
  .light-style .bs-stepper.wizard-modern {
    background-color: transparent;
  }
  .text-primary{
    color: #ce9c2b !important;
}
  </style>
  